type LoaderProps = {
    frame?: boolean
}

export default function Loader({ frame = false }: LoaderProps) {
    return (
        <div
            className={
                frame
                    ? "flex min-h-[calc(100dvh-112px)] w-full items-center justify-center md:min-h-[320px]"
                    : "flex w-full items-center justify-center py-8"
            }>
            <img src={require("../assets/pop-corn.gif")} alt="Loading..." />
        </div>
    )
}
